export const resolvePrefix = (path: string) => {
  if (
    process.env.NODE_ENV === 'production' &&
    !path.startsWith(process.env.GATSBY_ASSET_PREFIX)
  ) {
    return `${process.env.GATSBY_ASSET_PREFIX}${path}`
  }
  return path
}
